export const SEARCH_HSA_UNITS = "SEARCH_HSA_UNITS";
export const SET_HSA_UNITS = "SET_HSA_UNITS";
export const SET_CARE_PROVIDERS = "SET_CARE_PROVIDERS";
export const SET_CARE_UNITS = "SET_CARE_UNITS";
export const GET_LATEST_SUCCESSFUL_HSA_IMPORT =
  "GET_LATEST_SUCCESSFUL_HSA_IMPORT";
export const SET_LATEST_SUCCESSFUL_HSA_IMPORT =
  "SET_LATEST_SUCCESSFUL_HSA_IMPORT";
export const IMPORT_HSA_UNITS = "IMPORT_HSA_UNITS";
export const RESET_HSA = "RESET_HSA";

export const setLastImport = (lastImport: any) => ({
  type: SET_LATEST_SUCCESSFUL_HSA_IMPORT,
  lastImport,
});

export const setCareProviders = (careProviders: any) => ({
  type: SET_CARE_PROVIDERS,
  careProviders,
});
export const setCareUnits = (careUnits: any) => ({
  type: SET_CARE_UNITS,
  careUnits,
});

const initialState = {
  careProviders: [],
  careUnits: [],
  lastImport: null,
};

export const hsaReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_LATEST_SUCCESSFUL_HSA_IMPORT:
      const { lastImport } = action;
      return { ...state, lastImport };
    case SET_CARE_PROVIDERS:
      const { careProviders } = action;
      return { ...state, careProviders };
    case SET_CARE_UNITS:
      const { careUnits } = action;
      return { ...state, careUnits };
    case RESET_HSA:
      return initialState;
    default:
      return state;
  }
};
